import React, { useState, useEffect, useRef } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import ResultsGrid from "../ResultsGrid/ResultsGrid.js";
import { cacheDropdownData } from "../../Utils/DropDownCache.js";
import "./searchFormStyle.css";
import Erorrnotification from "../ErrorNotifications/Notifications.js";
import "./searchForm.scss";
import config from "../../Configurations/KodakConfigUI.json";
import { useTranslation } from "react-i18next";
import { RetrieveDropdown } from "../../Utils/ProstewardAPI.js";
import { LoadingPanel } from "../LoadComponent/Loader.js";
import { SetSessionItem } from "../../Utils/Cache.js";

export default function SearchGrid() {
  const config_Dropdown_values = config.searchForm_elements;
  const { t, i18n } = useTranslation();
  const [showGrid, setShowGrid] = useState(false);
  const [reportCategories, setReportCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedReportCategory, setSelectedReportCategory] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [formErrors, setFormErrors] = useState({
    reportCategory: "",
    country: "",
    language: "",
    CATALOGNumber: "",
    ProductName: "",
  });
  const [initialLangLoad, setInitialLangLoad] = useState({isLangDropdown:false});
  const [initalCountryLoad, setInitialCountryLoad] = useState({isCountryDropdown:false})
  const gridRef = useRef();

  async function loadDropdowns() {
    const dropdowns = config.search_dropdowns;
    let dropDown_values = null;
    dropdowns.forEach(async (dropdownItem) => {
      //TODO: replace the statement "dropdownItem !== 'report_categories' ? await RetrieveDropdown(dropdownItem) : ""  with " await RetrieveDropdown(dropdown) " once report_categories is fully implemented in the API.  
      dropDown_values = dropdownItem !== 'report_categories' ? await RetrieveDropdown(dropdownItem) : "";
      switch (dropdownItem) {
        case "report_categories":
          setReportCategories(
            cacheDropdownData(
              dropdownItem,
              () => t('report_Categories_dropdown', {returnObjects: true})
            )
          );
          break;
        case "DocumentCountry":
          setCountries(cacheDropdownData(dropdownItem, () => dropDown_values));
          setInitialCountryLoad( {isCountryDropdown:true})
          break;
        case "ProductLanguage":
          setLanguages(cacheDropdownData(dropdownItem, () => dropDown_values));
          setInitialLangLoad({isLangDropdown:true})
          break;
        default:
          break;
      }
    });
  }

  useEffect(() => {
    i18n.on('languageChanged', () => {
      setReportCategories(cacheDropdownData(config.search_dropdowns[0], () => t('report_Categories_dropdown', {returnObjects: true}), true))
    })
  }, [reportCategories])
 

  // Add error handling for fetching dropdown data
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        await loadDropdowns();
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        // shows error message to user
      }
    };
    fetchDropdownData();
  }, []);

  const handleSubmit = (dataItem) => {
    let formSubmitData = {};
    formSubmitData = constructData(formSubmitData, dataItem);
    if (validateForm(formSubmitData)) {
      setFormData(formSubmitData);
      setShowGrid(true);
      SetSessionItem("isNewRequest",true)
    } else {
      setShowGrid(false);
      SetSessionItem("isNewRequest",false)
    }
  };

  const constructData = (formSubmitData, dataItem) => {
    dataItem.CATALOGNumber = document.getElementById("CATALOGNumber").value;
    dataItem.ProductName = document.getElementById("ProductName").value;

    formSubmitData.selectedReportCategory = selectedReportCategory;
    formSubmitData.selectedCountry = selectedCountry;
    formSubmitData.selectedLanguage = selectedLanguage;
    formSubmitData.categoryValue = dataItem.CATALOGNumber ?? null;
    formSubmitData.productName = dataItem.ProductName ?? null;
    return formSubmitData;
  };

  const clearFormErrors = () => {
    setFormErrors({});
  };

  const validateForm = (dataItem) => {
    let isValid = true;
    const errors = {};

    if (!dataItem.categoryValue && !dataItem.productName) {
      errors.ProductName =errors.CATALOGNumber = 'Please enter CATALOG/REORDER number or PRODUCT NAME/KEYWORD.';
      isValid = false;
    } else {
      errors.CATALOGNumber = "";
      errors.ProductName = "";
    }

    setFormErrors(errors);
    return isValid;
  };

  const filterData = (arr, f) => {
    //return (arr.filter((items)=> items.toLowerCase().includes(event.target.value)))
    return filterBy(arr.slice(), f);
  };

  const filterChange = (event_trig_src, event) => {
    switch (event_trig_src) {
      case "report_categories":
        setReportCategories(
          filterData(
            cacheDropdownData(event_trig_src, t('report_Categories_dropdown', {returnObjects:true})),
            event.filter
          )
        );
        break;
      case "DocumentCountry":
        setCountries(
          filterData(
            cacheDropdownData(
              event_trig_src,
              async () => await RetrieveDropdown(event_trig_src)
            ),
            event.filter
          )
        );
        break;
      case "ProductLanguage":
        setLanguages(
          filterData(
            cacheDropdownData(
              event_trig_src,
              async () => await RetrieveDropdown(event_trig_src)
            ),
            event.filter
          )
        );
        break;
    }
  };

  return (
    <>
      {!(initalCountryLoad.isCountryDropdown && initialLangLoad.isLangDropdown) ? (
        <LoadingPanel />
      ) : (
        <>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement className="search-container">
                <fieldset style={{ border: "none" }}>
                  <div style={{ margin: "1em 0" }}>
                    <label>{t("reportCategory")}</label>
                    <ComboBox
                      data={reportCategories}
                      dataItemKey="CatogeryType"
                      textField="displayName"
                      aria-label="Report Category"
                      id="reportdDD"
                      onChange={(e) =>
                        setSelectedReportCategory(e.target.value)
                      }
                      value={selectedReportCategory}
                      filterable={true}
                      onFilterChange={(e) => filterChange(config.search_dropdowns[0], e)}
                    />
                  </div>
                  <div style={{ margin: "2em 0" }}>
                    <label>{t("country")}</label>
                    <ComboBox
                      id="CLDD"
                      data={countries}
                      dataItemKey="Id"
                      textField="Text"
                      onChange={(e) => setSelectedCountry(e.target.value)}
                      value={selectedCountry}
                      filterable={true}
                      onFilterChange={(e) =>
                        filterChange(config.search_dropdowns[1], e)
                      }
                    />
                  </div>
                  <div style={{ margin: "2em 0" }}>
                    <label>{t("language")}</label>
                    <ComboBox
                      id="LangDD"
                      data={languages}
                      dataItemKey="Id"
                      textField="Text"
                      name={"Language"}
                      onChange={(e) => {
                        setSelectedLanguage(e.target.value);
                      }}
                      value={selectedLanguage}
                      filterable={true}
                      onFilterChange={(e) =>
                        filterChange(config.search_dropdowns[2], e)
                      }
                    />
                  </div>
                  <div style={{ margin: "2em 0" }}>
                    <label>{t("catalogNumber")}</label>
                    <Field
                      name={"CATALOGNumber"}
                      type={"text"}
                      component={Input}
                      id="CATALOGNumber"
                    />
                  </div>
                  <div style={{ margin: "2em 0" }}>
                    <label>{t("productName")}</label>
                    <Field
                      name={"ProductName"}
                      type={"text"}
                      component={Input}
                      id="ProductName"
                    />
                  </div>
                  <div>
                    <button
                      className="search-button"
                      type="submit"
                      onClick={() => {
                        gridRef.current.scrollIntoView({behavior: 'smooth'});
                        clearFormErrors();
                        handleSubmit(formData);
                      }}
                    >
                      {t("search")}
                    </button>
                  </div>
                </fieldset>
              </FormElement>
            )}
          />
          {formErrors.ProductName && (
            <Erorrnotification
              errors={formErrors.ProductName}
              onErrorCompletion={clearFormErrors}
              type="warning"
              closeButton={true}
            />
          )}
          <div ref={gridRef} id="GridElement">
            {showGrid && <ResultsGrid searchCriteria={formData} />}
          </div>
        </>
      )}
    </>
  );
}
